
import { ElMessage } from "element-plus";
import { Aemet } from "@/types/aemet.type";
import { AppError } from "@/types/app.type";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { defineComponent } from "@vue/runtime-core";
import { postAemet } from "@/service/aemet.service";

const errorMessage = "error.required";
export default defineComponent({
  components: {},
  props: {
    id: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      aemetForm: {} as Aemet,
      samplingPointAemet: [] as SamplingPoint[],
      rules: {
        name: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
        code: [
          {
            required: true,
            message: this.$t(errorMessage),
            trigger: blur,
          },
        ],
      },
    };
  },
  async mounted() {
    // TODO
  },
  methods: {
    async doSave() {
      if (
        this.aemetForm.name === undefined ||
        this.aemetForm.code === undefined ||
        this.aemetForm.province === undefined
      ) {
        ElMessage.error(this.$t(errorMessage));
        throw new Error(AppError.FORM_VALIDATION);
      }

      return postAemet(this.aemetForm);
    },
  },
});
